import axios from 'axios';
import React, { useState } from 'react';
import { globalEnv } from '../../../../../config/baseConfig';
import { useNavigate, useParams } from 'react-router-dom';
import { useTypedSelector } from '../../../../../hooks/useTypeSelector';
import { useQuery } from 'react-query';

import placeholder from '../../../../../assets/images/img.jpg';
import { BottomBtn } from '../..';
import LoadingAnimComponent from '../../../../Utils/LoadingAnimations/loadingAnimation';
import { DataNotFoundAnimation } from '../../../../Utils/ErrorAnimations/dataNotFoundAnim';
import { Tag } from '../../../../Utils/Components/tag';
import { StyledBtn } from './sendEmailInCampaign';

export default function SingleCampaign() {
	const { campaignId } = useParams();

	const [campaignName, setCampaignName] = useState('');
	const [sentEmailsCount, setSentEmailsCount] = useState();
	const [pendingEmailsCount, setPendingEmailsCount] = useState();
	const [contactedUsers, setContactedUsers] = useState();
	const [tags, setTags] = useState<string[]>([]);

	const [isChanged, setIsChanged] = useState(false);
	const [nameErrorMsg, setNameErrorMsg] = useState({
		message: '',
		error: false
	});

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);
	const { data, isLoading, isError } = useQuery(
		['campaign', campaignId],
		() => fetchCampaign(),
		{
			cacheTime: 0,
			keepPreviousData: false,
			staleTime: 5000,
			refetchOnWindowFocus: false
		}
	);

	const fetchCampaign = async () => {
		const config = {
			headers: { Authorization: 'Bearer ' + ACCESS_TOKEN }
		};

		const { data } = await axios.get(
			globalEnv.BASE_URL + `/outreach/campaign/get-by-id/${campaignId}`,
			config
		);

		setCampaignName(data.name);
		setSentEmailsCount(data.sentEmails);
		setPendingEmailsCount(data.pendingEmails);
		setContactedUsers(data.contactedUsers);
		setTags(data.keywords);
		console.log(data);
		console.log(data.contactedUsers);
		return data;
	};

	function addTag() {
		setTags([...tags, '']);
	}

	const navigate = useNavigate();

	return (
		<div className="pt-16 pl-16">
			{isLoading ? (
				<LoadingAnimComponent />
			) : isError ? (
				<div className="h-full ml-16 ">
					<div className="flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
						<div className="mx-auto my-auto self-center">
							<div className="min-h-16">
								<DataNotFoundAnimation height={dimensions.height / 1.5} />
							</div>
							<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
								{"Couldn't find the data you're looking for!"}
							</h3>
						</div>
					</div>
				</div>
			) : (
				<div>
					<div className="w-full mt-2 px-6">
						<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">
							Compaign name
						</label>
						<input
							className="inputStyle"
							id="grid-last-name"
							type="text"
							placeholder="Write the name here"
							onChange={(e) => {
								setCampaignName(e.target.value);
							}}
							value={campaignName}
						/>
					</div>

					<div
						className="flex flex-row w-full lg:w-10/12 md:w-11/12 mt-5 mb-7 justify-start
												  sm:px-2 md:px-10 lg:px-6 lg:mt-3"
					>
						<div>
							<h3 className="font-bold mb-2 text-sm lg:text-base dark:text-gray-100">
								Keywords
							</h3>
							<div className="flex flex-row space-x-2">
								{tags != null &&
									tags.map((tag, index) => (
										<Tag
											name={tag}
											isMine={true}
											setIsChanged={setIsChanged}
											index={index}
											setTags={setTags}
											tags={tags}
										/>
									))}

								{tags != null ? (
									tags.length > 0 ? (
										<div
											className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
										>
											<span className="text-xs font-bold mx-1" onClick={addTag}>
												➕
											</span>
										</div>
									) : (
										<div className="inline-block">
											<span className="text-xs font-bold mx-1 text-gray-400">
												Campaign has no keywords
											</span>
											<div
												className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
											>
												<span
													className="text-xs font-bold mx-1"
													onClick={addTag}
												>
													Add first keyword ➕
												</span>
											</div>
										</div>
									)
								) : (
									<div className="inline-block">
										<span className="text-xs font-bold mx-1 text-gray-400">
											Campaign has no keywords
										</span>
										<div
											className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 
																	bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
																	dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
																	dark:text-gray-300 text-gray-600 hover:text-gray-200"
										>
											<span className="text-xs font-bold mx-1" onClick={addTag}>
												Add first keyword➕
											</span>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="flex flex-row">
						<StyledBtn
							title="Sent emails:"
							imgPath={placeholder}
							subTitle={sentEmailsCount}
							action={() => {
								navigate(`../outreach/campaign/${campaignId}/sent-emails`);
							}}
						/>
						<StyledBtn
							title="Pending emails:"
							imgPath={placeholder}
							subTitle={pendingEmailsCount}
							action={() => {
								navigate(`../outreach/campaign/${campaignId}/pending-emails`);
							}}
						/>
					</div>
					<div className="flex flex-row">
						<StyledBtn
							title="Analytics"
							imgPath={placeholder}
							subTitle={''}
							action={() => {
								navigate(`../outreach/campaign/${campaignId}/analytics`);
							}}
						/>
						<StyledBtn
							title="Contacted users:"
							imgPath={placeholder}
							subTitle={contactedUsers}
							action={() => {
								navigate(`../outreach/campaign/${campaignId}/contacted-users`);
							}}
						/>
					</div>

					<BottomBtn
						name="Add email batch"
						action={() =>
							navigate(`../outreach/campaign/${campaignId}/select-template`)
						}
					/>
				</div>
			)}
		</div>
	);
}
